<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button [disabled]="formInvalid" type="button" class="btn btn-outline-success" (click)="onSave($event)" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
        <ng-container *ngIf="periodoHabilitadoParaVariedades">
            <button [disabled]="esPeriodoFinalizado" class="btn btn-outline-success" type="button" (click)="onAdd($event)" title="Añadir Variedad">
                <i class="fa fa-file-o"></i> Añadir Variedad
            </button>
        </ng-container>
        <ng-container *ngIf="!periodoHabilitadoParaVariedades">
            <div *ngIf="periodoCam" class="ms-1 nota-info">
                <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Periodo no habilitado para incluir Variedades</label>
            </div>
        </ng-container>
        <div *ngIf="periodoCam && esPeriodoFinalizado" class="ms-1 nota-info">
            <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Periodo finalizado</label>
        </div>
    </form>
</nav>

<div class="container-fluid container-fluid-list">
    <app-periodos-variedad-list *ngIf="searching" [variedadesDePeriodo]="variedadesDePeriodo" [datosPeriodo]="datosPeriodo" 
        [esPeriodoFinalizado]="esPeriodoFinalizado" [esVigenteConSolicitudes]="esVigenteConSolicitudes" 
        (delete)="onDelete($event)"></app-periodos-variedad-list>
</div>

<ng-container *ngIf="dialogComponentVisible">
    <app-dialog [title]="dialogTitle" [disabled]="preSelection === null" [template]="buscadorVariedad" (accepted)="onDialogAccepted($event)"></app-dialog>

    <ng-template #buscadorVariedad>
        <app-variedad-buscador [dialogMode]="true" [selectionMode]="dialogSelectionMode"
            (selectVariedad)="onSelectVariedad($event)" (undoSelectVariedad)="onUndoSelect($event)"></app-variedad-buscador>
    </ng-template>
</ng-container>
